import {
  DTNode,
  DTOptimizationNode,
  OptimizationNodeOutputData,
} from 'common/src/modules/decisionTree/decisionTree.types';
import {ServerNode} from 'common/src/modules/nodes/nodes.types';
import {trimDescription} from 'common/src/modules/campaigns/utils/trimDescription';

export function serializeOptimizationNode(node: DTNode, newNode: ServerNode) {
  const optimizationNode = node as DTOptimizationNode;

  return {
    ...newNode,
    description: trimDescription(newNode.description),
    configuration: optimizationNode.configuration,
    outputs: (node.outputs as OptimizationNodeOutputData[]).map((output) => {
      return {nodeId: output.nodeId, id: output.id, name: output.name};
    }),
  };
}

